/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_FulfillmentsInputs */

const en_nav_fulfillments = /** @type {(inputs: Nav_FulfillmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulfillments`)
};

/**
* | output |
* | --- |
* | "Fulfillments" |
*
* @param {Nav_FulfillmentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_fulfillments = /** @type {((inputs?: Nav_FulfillmentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_FulfillmentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_fulfillments(inputs)
});